<div class="progress-stepper-container">
  @for (step of steps; track step; let index = $index) {
    <pc-progress-step-indicator
      tabindex="0"
      [attr.aria-disabled]="index > selectedIndex"
      [isAnimated]="selectedIndex === index"
      [isClickable]="isStepClickable(index)"
      [position]="index === 0 ? BarPosition.Start : index + 1 === steps.length ? BarPosition.End : BarPosition.Middle"
      [progress]="
        index < selectedIndex ? ProgressValues.OneHundred : index === selectedIndex ? progress : ProgressValues.Zero
      "
      [stepName]="step.label"
      (click)="onStepClicked(index)"
    >
    </pc-progress-step-indicator>
  }
  @if (completedPercentageTranslate() && !isMobile()) {
    <p class="body-semi percentage">{{ totalProgress }}% {{ completedPercentageTranslate() }}</p>
  }
</div>
<div class="vertical-stepper" [class.hidden]="!isMobile()">
  <pc-vertical-stepper
    [accessibilityStatementText]="accessibilityStatementText()"
    [currentStep]="progressStepperService.selectedIndex()"
    [headerIcon]="headerIcon()"
    [isDevMode]="isDevMode()"
    [isStepClickable]="isStepClickable"
    [progressSteps]="steps"
    (onAccessibilityStatementClicked)="accessibilityStatementClicked()"
    (requestedStepSelected)="onStepClicked($event)"
  >
    <ng-content custom-element select="[custom-btn]"></ng-content>
  </pc-vertical-stepper>
</div>
<div [ngTemplateOutlet]="selected ? selected.content : null"></div>
